import { Component, OnInit } from '@angular/core';
declare const $: any;


@Component({
  selector: 'app-ourvision',
  templateUrl: './ourvision.component.html',
  styleUrls: ['./ourvision.component.css']
})
export class OurvisionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    //this.ngLoadJquery();

  }


  ngLoadJquery() {
    /* ==================================================
      # Youtube Video Init
   ===============================================*/
    $('.player').mb_YTPlayer();
    /* ==================================================
        # Magnific popup init
     ===============================================*/
    $(".popup-link").magnificPopup({
      type: 'image',
      // other options
    });

    $(".popup-gallery").magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      },
      // other options
    });

    $(".popup-youtube, .popup-vimeo, .popup-gmaps").magnificPopup({
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  }

}
